import React, { useContext, useEffect, useState } from "react";
import BarChart from "./BarChart";
import AuthContext from "../../../contexts/auth-context";
import useAxios from "../../../hooks/useAxios";
import { urls } from "../../config/variables";
import { validateHighDrugSpend } from "../../../Utils/validateHttpResponse";
import Toastify from "../../ui/Toastify";
import { toastify_status } from "../../config/variables";
import AppContext from "../../../contexts/app-context";

const HighetDrugSpend = () => {
  const [data, setData] = useState([]);
  const { operation } = useAxios();
  const authCtx = useContext(AuthContext)
  const token = authCtx.token;
  const { globalFilterQuery } = useContext(AppContext);

  const fetchData = () => {
    operation(
      {
        method: 'GET',
        url: urls.HIGH_DRUG_SPENDING + globalFilterQuery,
        headers: { Authorization: `token ${token}` },
        data: {},
      },
      handleSetData,
      handleSetDataError
    );
  }
  useEffect(() => {
      fetchData()
      // eslint-disable-next-line
  }, []);
  
  const handleSetData = (response) => {
    if (validateHighDrugSpend(response)) {
      setData(response);
    } else {
      Toastify({
        message: "Invalid high drug spend response data",
        state: toastify_status.ERROR,
      });
    }
  }

  const handleSetDataError = (error) => {
    console.log(error)
  }

  const xAxisData = data.map((item) => item.name);

  const providerNames = Array.from(
    new Set(data.flatMap((item) => item.providers.map((p) => p.provider_name)))
  );

  const series = providerNames.map((provider, index) => ({
    name: provider,
    type: "bar",
    stack: "total",
    emphasis: { focus: "series" },
    data: data.map((patient) => {
      const found = patient.providers.find(
        (p) => p.provider_name === provider
      );
      return found ? parseFloat(found.provider_cost) : 0;
    }),
    label: {
      show: index === providerNames.length - 1,
      position: "top",
      formatter: (params) => {
        if (index === providerNames.length - 1) {
          const patient = data[params.dataIndex];
          return `$${parseFloat(patient.total_cost)}`;
        }
        return "";
      },
    },

  }));

  const option = {
    tooltip: {
      trigger: "axis",
      axisPointer: { type: "shadow" },
      valueFormatter: (val) => `$${val.toLocaleString()}`,
    },
    legend: {
      data: providerNames,
      type: "scroll"
    },
    xAxis: {
      type: "category",
      data: xAxisData,
      axisLabel: {
        interval: 0,
        overflow: "break",
        formatter: function (value) {
          const maxLength = 25;
          if (value.length > maxLength) {
            return value.match(new RegExp('.{1,' + maxLength + '}', 'g')).join('\n');
          }
          return value;
        },
      },
    },
    yAxis: {
      type: "value",
      axisLabel: {
        formatter: (val) => `$${val}`,
      },
    },
    series,
    title: {
      text: "Patients with high medication costs",
      subtext: 'Top 5 patients with the highest medication costs, with total spend and provider-level breakdown',
      left: "center",
      top: 10,
      textStyle: {
        fontSize: 16,
        fontWeight: "bold",
      },
    },
    grid: {
      top: 80,
      bottom: 80,
      left: 60,
      right: 30,
    },
  };

  return <BarChart name='Highet Drug Spend' option={option} dataLength={data.length} />;
};

export default HighetDrugSpend;
